import gameiomModel from "gameiom/model/gameiom-model";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import BetBarComponent from "slotworks/components/betbar/bet-bar-component";
import Layers from "slotworks/graphics/layers/layers";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";
import {UiDenomDisplayType} from "gameiom/wrapper/wrapper-data";
import { Services } from "slotworks/services/services";

export default class AGSBetBarComponent extends BetBarComponent {
    public constructor() {
        super();

        const TITLE_ID = "DENOM";
        const TITLE_ALIAS = "bet.mul";

        if (gameiomModel.displayCurrency) {
            BetBarType.DEFAULT = new BetBarType("default_currency");
            BetBarType.FREESPINS = new BetBarType("freespins_currency");

            let group = SmartUIManager.newSmartUIGroup(Layers.BetBar, BetBarType.DEFAULT.toString(), "betbar_" + BetBarType.DEFAULT.toString());
            group.addEnableCondition([SmartUIFlag.IDLE]);
            group.addDisableCondition([SmartUIFlag.PROMPT]);
            group.addDisableCondition([SmartUIFlag.AUTO_SPIN]);

            group = SmartUIManager.newSmartUIGroup(Layers.BetBar, BetBarType.FREESPINS.toString(), "betbar_" + BetBarType.FREESPINS.toString());
            group.addDisableCondition([SmartUIFlag.FREE_SPINS]);
            group.addDisableCondition([SmartUIFlag.AUTO_SPIN]);
        }

        if (gameiomModel.denomDisplay && gameiomModel.denomDisplay === UiDenomDisplayType.multiplier) {
            const scenes = Layers.BetBar.getScenes();
            scenes.forEach((scene) => {
                const texts = scene.config.text;
                for (const text in texts) {
                    if (texts[text].id === TITLE_ID) {
                        texts[text].content = `[${TITLE_ALIAS}]`;
                        break;
                    }
                }
            });
            if (Layers.BetBar.getText(TITLE_ID)){
                Layers.BetBar.getText(TITLE_ID).text = Services.translations.get(TITLE_ALIAS);
            }
        }

        this.setType(BetBarType.DEFAULT);
    }
}
